<template>
    <div class="award">
      <div class="show-page">
        <div class="left">
          <img :src="awardImgUrl" class="left-img">
        </div>
        <div class="right">
            <div class="font-area">
              <p class="title" :class="globalTransition">{{$t('aboutPage.p5.title1')}}<br>
                {{$t('aboutPage.p5.title2')}}</p>
              <p class="content" :class="globalTransition">{{$t('aboutPage.p5.content')}}</p>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'aboutAward',
  data() {
    return {
      // eslint-disable-next-line
      awardImgUrl: require('../../assets/awards.jpg'),
    };
  },
  computed: {
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
};
</script>

<style lang="scss" scoped>
.award{
  width: 100%;
  padding: 6% 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  .show-page{
    width: 88%;
    display: flex;
    flex-wrap: nowrap;
    .left{
      width: 70%;
      .left-img{
        width: 100%;
        height: 100%;
      }
    }
    .right{
      background-color: #000;
      width: 30%;
      height: 100%;
      .font-area{
        padding: 20% 19%;
        .title{
          color: #369ff6;
          font-size: 2rem;
          font-weight: bold;
        }
        .content{
          margin-top: 20%;
          color: #fff;
          font-size: 1.2rem;
          line-height: 2rem;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/aboutPage/award.vue